import { useState, useEffect } from "react";
import BreadCrumb from "../Controls/BreadCrumb";
import AdminAgreementListItem from "./AdminAgreementListItem";
import AdminAgreementDetailsModal from "./AdminAgreementDetailsModal";
import "../../style/scss/App.scss";
import API from "../../API";

export default function AdminAgreements() {
  const [agreements, setAgreements] = useState([]);
  const [agreementModal, setAgreementModal] = useState(null);

  async function reload() {
    const resp = await API.getAsync("/Agreements");
    if (resp?.ok) {
      setAgreements(resp.jsonData || []);
    }
  }

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const resp = await API.getAsync("/Agreements");
      if (!cancelled && resp?.ok) {
        setAgreements(resp.jsonData || []);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <BreadCrumb props={["Admin", "Master Agreements List"]} />
      <div className="tabbody">
        <h2>Agreements Master List</h2>
        <ul>
          {(agreements || []).map((a) => {
            return (
              <AdminAgreementListItem
                key={a.ID ?? a.id}
                agreement={a}
                onView={(agr) => setAgreementModal(agr)}
              />
            );
          })}
        </ul>
      </div>
      {agreementModal ? (
        <AdminAgreementDetailsModal
          agreement={agreementModal}
          onClose={() => setAgreementModal(null)}
          onUpdated={async () => {
            await reload();
            setAgreementModal(null);
          }}
        />
      ) : null}
    </div>
  );
}
